import {
  useCreateOperation,
  useFetchSuggestOperations,
} from "@/lib/queries/hooks";
import Dropdown from "@/lib/Dropdown";
import Menu from "@/lib/Menu";
import Button from "@/lib/Button";
import PlusIcon from "~icons/local/plus";
import { useState } from "react";
import OperationTypeIcon from "./OperationTypeIcon";

export default function AddOperation({
  ordinal,
  last,
}: {
  ordinal: string;
  last?: boolean;
}) {
  const suggestOperations = useFetchSuggestOperations() ?? [];
  const { createOperation } = useCreateOperation();

  const [searchTerm, setSearchTerm] = useState("");
  const filteredOperations = suggestOperations.filter((op) =>
    op.name.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  const trigger = last ? (
    <Button>Add operation</Button>
  ) : (
    // unfortunately we can't have `left-[-0.5rem]` here because parent sets the `overflow-y-auto` which means computed `overflow-x` will also be `auto`
    <div className="bg-white rounded-full p-0.5 invisible group-hover/add-operation:visible absolute top-[-0.25rem] shadow-md z-10">
      <PlusIcon className="size-3 text-blue-400 hover:text-blue-600 fill-current" />
    </div>
  );

  return (
    <Dropdown trigger={trigger} placement="bottom-start">
      <div>
        <input
          placeholder="Filter operations..."
          className="w-full px-4 py-1 border rounded"
          autoFocus
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <Menu
          className="text-gray-800 max-h-96 overflow-y-auto"
          itemGroups={[
            filteredOperations.map(({ name, type }) => ({
              label: (
                <div className="flex items-center gap-1">
                  <OperationTypeIcon operationType={type} className="size-4" />
                  <span className="ml-2">{name}</span>
                </div>
              ),
              click: () => {
                createOperation({
                  name,
                  type,
                  ordinal,
                  draft: {},
                });
              },
            })),
          ]}
        />
      </div>
    </Dropdown>
  );
}
